import { Extension } from '@tiptap/core';
import { ZyDEInstruction, ZyDEInstructionHeadless, ZyDENode, ZyDENodeHeadless } from './zyde-extension';

export const ZyDEHeadless = Extension.create({
    name: 'zyDEWrapper',

    addExtensions() {
        return [ZyDEInstructionHeadless, ZyDENodeHeadless];
    },
});

export const ZyDE = ZyDEHeadless.extend({
    addExtensions() {
        return [ZyDEInstruction, ZyDENode];
    },
});

export default ZyDE;
